import React from 'react';

const Features: React.FC = () => {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Enterprise Security',
      description: 'Advanced security features with compliance management, threat detection, and real-time monitoring to protect your IT infrastructure.',
      stats: '99.9% Uptime'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Multi-Cloud Support',
      description: 'Seamless integration across on-premises, public cloud, and hybrid environments with unified management capabilities.',
      stats: '50+ Integrations'
    },
    {
      icon: 'ri-robot-line',
      title: 'AI-Powered Automation',
      description: 'Intelligent automation and machine learning capabilities to streamline IT operations and reduce manual tasks.',
      stats: '80% Time Saved'
    },
    {
      icon: 'ri-team-line',
      title: 'Global Support',
      description: '24/7 expert support with dedicated customer success teams and comprehensive training resources worldwide.',
      stats: '280K+ Customers'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Unified Dashboard',
      description: 'Centralized monitoring and management with customizable dashboards and real-time analytics for better visibility.',
      stats: 'Real-time Data'
    },
    {
      icon: 'ri-award-line',
      title: 'Industry Recognition',
      description: 'Award-winning solutions recognized by leading industry analysts and trusted by enterprises globally.',
      stats: '120+ Products'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Why Choose ManageEngine?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trusted by enterprises worldwide for comprehensive IT management and security solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group bg-gray-50 rounded-xl p-8 hover:bg-blue-50 transition-all duration-300 hover:shadow-lg">
              <div className="w-16 h-16 bg-blue-100 group-hover:bg-blue-200 rounded-full flex items-center justify-center mb-6 transition-colors">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{feature.description}</p>
              
              <div className="flex items-center justify-between">
                <span className="text-2xl font-bold text-blue-600">{feature.stats}</span>
                <i className="ri-arrow-right-line text-blue-600 text-xl group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Stats Section */}
        <div className="mt-20 bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-12 text-white">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold mb-4">Proven Track Record</h3>
            <p className="text-xl opacity-90">Numbers that speak for our excellence</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">280K+</div>
              <div className="text-lg opacity-90">Global Customers</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">120+</div>
              <div className="text-lg opacity-90">IT Products</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">25+</div>
              <div className="text-lg opacity-90">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">99.9%</div>
              <div className="text-lg opacity-90">Service Uptime</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;